import UserDuplicateListActionTypes from '../actions/user-duplicate-list-action-types';

const initialState = {
  loading: false,
  userDuplicatesCancelToken: null,
  isConfirmDialogVisible: false,
  mergeWithUser: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case UserDuplicateListActionTypes.MERGE_USER_DUPLICATES_START:
      return {
        ...state,
        loading: true
      };
    case UserDuplicateListActionTypes.MERGE_USER_DUPLICATES_END:
      return {
        ...state,
        mergeWithUser: null,
        loading: false
      };
    case UserDuplicateListActionTypes.TOGGLE_USER_MERGE_CONFIRM_DIALOG:
      return {
        ...state,
        mergeWithUser: action.payload,
        isConfirmDialogVisible: !state.isConfirmDialogVisible
      };
    default:
      return state;
  }
};
